import React, { useState, useEffect, useRef } from 'react';
import CkEditor from '../../constants/CkEditor';
import { toast } from 'react-toastify';
import {
    Table, Button, Form, FormGroup, Label, Input, Card, CardBody, CardTitle
    , Row, Col, FormText, Alert
} from 'reactstrap';
import { apiService } from '../../constants/ApiService';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../layouts/loader/Loader';
import ErrorModal from '../../constants/ErrorModal';
import { useSelector } from 'react-redux';
const API_URL = process.env.REACT_APP_API_BASE_URL;

const AddVenderMaster = () => {

    const [editorLoaded, setEditorLoaded] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false)
    const { user } = useSelector((state) => state.authState);
    const [companyDetail, setCompanyDetail] = useState({
        vender_name: '',
        vender_address: '',
        vender_mobile: '',
        vender_mobile_code: "+91",
        vender_email: '',
        vender_city: 54,
        vender_state: 11,
        vender_pincode: null,
        vender_country: 'India',

        vender_contact_no: '',
        vender_registration_number: '',
        vender_type: '',
        vender_status: 'Active',
        vender_website: '',
        vender_logo: '',
        vender_established_year: '',
        vender_tax_id: '',
        vender_notes: '',
        branch_id_and_names: '0-0',
        sub_branch_id_and_names: '0-0'
    });
    const [venderWebsitePage, setVenderWebsitePage] = useState({
        id: null,
        company_image: "",
        company_logo: "",
        company_name: "",
        email_sender: "",
        company_address: "",
        company_address_1: "",
        company_phone: "",
        company_about_title: "",
        company_about: "",
        footer_company_about: "",
        private_policy: "",
        term_condition: "",
        facebook_link: "",
        twitter_link: "",
        youtube_link: "",
        linkedin_link: "",
        map_link: "",
        business_card_link: "",
        delete_option: "",
        created_on: "",               // "2025-06-27T00:00:00" or similar format
        updated_on: "",               // same format as created_on
        unique_trn_id: null,
        client_purchaser_code: "",
        client_purchaser_name: "",
        agent_code: "",
        agent_name: "",
        company_owner_code: "",
        company_owner_name: "",
        vender_master_id: null,
        branch_master_id: null,
        session_year: "",
        session_year_id: "",


        comp_meta_title: "",
        comp_meta_desc: "",
        comp_meta_keyword: "",
        about_us_meta_title: "",
        about_us_meta_desc: "",
        about_us_meta_keyword: "",
    });
    const [previewVenderWebsiteImage, setPreviewVenderWebsiteImage] = useState(null);
    const [previewVenderWebsiteLogo, setPreviewVenderWebsiteLogo] = useState(null);
    const [previewVenderWebsiteBreadcrumbImg, setPreviewVenderWebsiteBreadcrumbImg] = useState(null);

    const companyTypes = [
        { id: 1, type: 'LLC' },
        { id: 2, type: 'Corporation' },
        { id: 3, type: 'Sole Proprietorship' },
        { id: 4, type: 'Partnership' },
        { id: 5, type: 'Non-Profit' }
    ];
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});

    const inlineStyles = {
        button: {
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer'
        }
    };
    const [editMode, setEditMode] = useState(false)
    const productImageRef = useRef(null)

    const [previewImage, setPreviewImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [stateTable, setStateTable] = useState([]);
    const [cityTable, setCityTable] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (event) => {
        const { name, value, type, files } = event.target;

        if (type === 'file') {

            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(files[0]);

            setCompanyDetail((prevData) => ({
                ...prevData,
                [name]: files[0],
            }));
        } else {
            setCompanyDetail((prevCompany) => ({
                ...prevCompany,
                [name]: value,
            }));
        }

        // Clear the validation error if the field has a valid value
        if (value.trim() !== '') {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }
    };

    const onChangeHandle = (e) => {
        const { name, value, type, files } = e.target;

        if (type === 'file') {

            if (name === "company_logo") {

                const file = files[0];
                setVenderWebsitePage((prevData) => ({
                    ...prevData,
                    [name]: file,
                }));

                // Create a preview URL for the image
                const filePreviewURL = URL.createObjectURL(file);
                setPreviewVenderWebsiteLogo(filePreviewURL);

            }
            if (name === 'company_image') {
                const file = files[0];
                setVenderWebsitePage((prevData) => ({
                    ...prevData,
                    [name]: file,
                }));

                // Create a preview URL for the image
                const filePreviewURL = URL.createObjectURL(file);
                setPreviewVenderWebsiteImage(filePreviewURL);

            }

            if (name === "breadcrumb_img") {
                const file = files[0];
                setVenderWebsitePage((prevData) => ({
                    ...prevData,
                    [name]: file,
                }));

                // Create a preview URL for the image
                const filePreviewURL = URL.createObjectURL(file);
                setPreviewVenderWebsiteBreadcrumbImg(filePreviewURL);
            }
        }
        else if (name === 'home_state') {
            let findArray = stateTable.find(data => data.state_Name === value);

            setVenderWebsitePage((prevData) => ({
                ...prevData,
                [name]: value,
                "home_state_code": findArray?.state_Code,
            }));

        } else {
            setVenderWebsitePage((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear the previous error when the user starts typing
        }));
    };

    const onHandleBack = () => {
        navigate(-1)
    };


    async function uploadImagesFromArrayWithIndex(obj) {

        if (obj.vender_logo && typeof obj.vender_logo === 'object' && obj.vender_logo !== null && 'name' in obj.vender_logo) {
            try {
                const imageUrl = await uploadImage(obj.vender_logo);
                obj.vender_logo = imageUrl;
            } catch (error) {
                console.error(`Error uploading image`, error);
            }

        }

        console.log(obj, 'object dat ')

        // Upload nested company_logo and company_image (if venderWebsiteKey exists)
        if (obj.venderWebsiteKey) {
            const logo = obj.venderWebsiteKey.company_logo;
            if (logo && typeof logo === "object" && logo !== null && "name" in logo) {
                try {
                    const imageUrl = await uploadImage(logo);
                    obj.venderWebsiteKey.company_logo = imageUrl;
                } catch (error) {
                    console.error("Error uploading company_logo", error);
                }
            }

            const image = obj.venderWebsiteKey.company_image;
            if (image && typeof image === "object" && image !== null && "name" in image) {
                try {
                    const imageUrl = await uploadImage(image);
                    obj.venderWebsiteKey.company_image = imageUrl;
                } catch (error) {
                    console.error("Error uploading company_image", error);
                }
            }


            const breadcrumb_img = obj.venderWebsiteKey.breadcrumb_img;
            if (breadcrumb_img && typeof breadcrumb_img === "object" && breadcrumb_img !== null && "name" in breadcrumb_img) {
                try {
                    const imageUrl = await uploadImage(breadcrumb_img);
                    obj.venderWebsiteKey.breadcrumb_img = imageUrl;
                } catch (error) {
                    console.error("Error uploading breadcrumb_img", error);
                }
            }
        }


        // if (obj.venderWebsiteKey.company_logo && typeof obj.venderWebsiteKey.company_logo === 'object' && obj.venderWebsiteKey.company_logo !== null && 'name' in obj.venderWebsiteKey.company_logo) {
        //     try {
        //         const imageUrl = await uploadImage(obj.venderWebsiteKey.company_logo);
        //         obj.venderWebsiteKey.company_logo = imageUrl;
        //     } catch (error) {
        //         console.error(`Error uploading image`, error);
        //     }

        // }

        //  if (obj.venderWebsiteKey.company_image && typeof obj.venderWebsiteKey.company_image === 'object' && obj.venderWebsiteKey.company_image !== null && 'name' in obj.venderWebsiteKey.company_image) {
        //     try {
        //         const imageUrl = await uploadImage(obj.venderWebsiteKey.company_image);
        //         obj.venderWebsiteKey.company_image = imageUrl;
        //     } catch (error) {
        //         console.error(`Error uploading image`, error);
        //     }

        // }
    }

    async function uploadImage(image) {
        const uploadData = new FormData();
        uploadData.append('signature', image);

        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'accept': 'application/json'
            }
        };

        try {
            const response = await apiService.post("/api/VenderMaster/uploadfile", uploadData, config);
            if (response.status === true) {
                return response.data;
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (error) {
            throw new Error("Failed to upload image: " + error.message);
        }
    }


    const validateVendorForm = (vendor) => {
        const errors = {};

        // Check if vender_name is not empty
        if (!companyDetail.vender_name.trim()) {
            errors.vender_name = "Name is required.";
        }

        // Check if vender_address is not empty
        if (!companyDetail.vender_address.trim()) {
            errors.vender_address = "Address is required.";
        }

        // Check if vender_mobile is a valid 10-digit number
        if (!companyDetail.vender_mobile || !/^\d{10}$/.test(companyDetail.vender_mobile)) {
            errors.vender_mobile = "Enter a valid 10-digit mobile number.";
        }

        // Check if vender_mobile_code is not empty
        if (!companyDetail.vender_mobile_code.trim()) {
            errors.vender_mobile_code = "Mobile code is required.";
        }

        // Validate email format
        if (!companyDetail.vender_email.trim()) {
            errors.vender_email = "Email is required.";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(companyDetail.vender_email)) {
            errors.vender_email = "Enter a valid email address.";
        }

        // Check if vender_city is not null
        if (!companyDetail.vender_city) {
            errors.vender_city = "City is required.";
        }

        // Check if vender_state is not null
        if (!companyDetail.vender_state) {
            errors.vender_state = "State is required.";
        }

        // Check if vender_pincode is a valid number
        if (!companyDetail.vender_pincode || !/^\d{6}$/.test(companyDetail.vender_pincode)) {
            errors.vender_pincode = "Enter a valid 6-digit pin code.";
        }

        // Check if vender_country is not empty
        if (!companyDetail.vender_country.trim()) {
            errors.vender_country = "Country is required.";
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const handleSubmit = async () => {

        // If already submitting, do nothing
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);



        let validation = validateVendorForm()
        if (!validation) {
            setIsSubmitting(false);

            setShowErrorModal(true)
            return
        }

        try {

            setLoading(true)
            let params = {
                ...companyDetail,
                venderWebsiteKey: { ...venderWebsitePage }
            }
            await uploadImagesFromArrayWithIndex(params)

            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };
            const response = await apiService.post(`api/VenderMaster/create`, params, config)
            setLoading(false)

            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                toast.success(response.message);
                navigate("/vendor")
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
        finally {
            setIsSubmitting(false); // Re-enable button
            setLoading(false);

        }
    }

    const getCompanyDetail = async (companyId) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/VenderMaster/detailById?companyId=${companyId}`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                setCompanyDetail(response.venderMasterByID)
                setVenderWebsitePage(response.venderWebsiteByID)

                if (response.venderWebsiteByID && response.venderWebsiteByID?.company_image) {
                    setPreviewVenderWebsiteImage(API_URL + response?.venderWebsiteByID?.company_image)
                }

                if (response.venderWebsiteByID && response.venderWebsiteByID.company_logo) {
                    setPreviewVenderWebsiteLogo(API_URL + response?.venderWebsiteByID?.company_logo)
                }

                if (response.venderWebsiteByID && response.venderWebsiteByID.breadcrumb_img) {
                    setPreviewVenderWebsiteBreadcrumbImg(API_URL + response?.venderWebsiteByID?.breadcrumb_img)
                }
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    };

    const UpdateCompanyDetail = async () => {

        // If already submitting, do nothing
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        let validation = validateVendorForm()
        if (!validation) {
            setShowErrorModal(true)
            setIsSubmitting(false);
            return
        }

        try {

            setLoading(true)

            let params = {
                ...companyDetail,
                venderWebsiteKey: { ...venderWebsitePage }
            }

            await uploadImagesFromArrayWithIndex(params)
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };


            const response = await apiService.put(`api/VenderMaster/update?companyId=${companyDetail.id}`, params, config)
            setLoading(false)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                alert(response.message)
                navigate("/vendor")

                // setPortfolioData(initial)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
        finally {
            setIsSubmitting(false); // Re-enable 
            setLoading(false);

        }

    }

    const goTODeleteModel = (id) => {
        const currentUrl = `${window.location.origin}`;
        const url = `${currentUrl}/commonDelete?itemId=${id}&flag=timber_owner`;
        window.open(url, '_blank');

        setTimeout(() => {
            window.close();
        }, 1000);
    };


    useEffect(() => {
        if (location.state) {
            getCompanyDetail(location.state.companyId)
            setEditMode(true)
        }
    }, [location.state]);

    // get state
    const getState = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/HelperMaster/allState`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                setStateTable(response.state_Master)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }

    // get city
    const getCity = async () => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/CityMaster/allCitys?stateId=${companyDetail.vender_state}`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                setCityTable(response.city_MasterDetailData)
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }

    useEffect(() => {
        if (companyDetail?.vender_state) {
            getCity()
        }
    }, [companyDetail?.vender_state])

    useEffect(() => {
        getState()
    }, [])


    const [helperMasterBusinessMode, setHelperMasterBusinessMode] = useState([]);

    const getHelperMaster = async (formName) => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/HelperMaster/allOption?fromName=${formName}`, config)
            if (response.response && response.response.data.errors) {
                toast.error(response.response?.data?.errors);
            }

            if (response.status === true) {
                if (formName === "working_bussinesss_mode") {
                    setHelperMasterBusinessMode(response.helperMasterData);
                }

            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
            toast.error(`SomeThing went wrong!!`);
        }
    }

    useEffect(() => {
        getHelperMaster("working_bussinesss_mode")
    }, [])


    // Inline styles for the inputs and layout
    const customSelectStyle = {
        padding: '10px',
        border: '2px solid #007bff', // Blue border
        borderRadius: '5px',
        backgroundColor: 'white', // Light background
        fontSize: '16px',
        transition: 'border-color 0.3s ease',
    };

    const customInputStyle = {
        padding: '10px',
        border: '2px solid #007bff', // Blue border
        borderRadius: '5px',
        backgroundColor: 'white', // Light background
        fontSize: '16px',
        transition: 'border-color 0.3s ease',
    };

    const containerStyle = {
        maxWidth: '900px',
        margin: 'auto',
        paddingTop: '30px',
    };

    const formGroupStyle = {
        // marginBottom: '1.5rem',
    };

    return (
        <Row>
            <Col>
                <Card className='bg-white pd-10 card-box mb-30'>
                    <CardTitle tag="h5" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between sticky-top">


                        {editMode ?

                            <div className="d-flex align-items-center">
                                <i className="bi bi-bell mr-2"></i>
                                Edit Vender Detail
                            </div>
                            :
                            <div className="d-flex align-items-center">
                                <i className="bi bi-bell mr-2"></i>
                                Add Vender Detail
                            </div>
                        }


                        {user.user_profile === "superadmin" && <>
                            {editMode ?
                                <>
                                    <Button color="danger" className="ml-auto mr-2" onClick={() => goTODeleteModel(companyDetail.id)}>
                                        <i className="bi bi-trash"></i>
                                        <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Delete</p>
                                    </Button>

                                    <Button type="button" color="success" disabled={isSubmitting}
                                        className="mr-2"
                                        onClick={UpdateCompanyDetail}>
                                        {loading ? <Loader /> : <>
                                            <i className="bi bi-save"></i>
                                            <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Update</p>
                                        </>}
                                    </Button>
                                </>
                                : <Button type="button" color="success" disabled={isSubmitting}
                                    className="ml-auto mr-2"
                                    onClick={handleSubmit}>
                                    {loading ? <Loader /> : <>
                                        <i className="bi bi-save"></i>
                                        <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Save</p>
                                    </>}
                                </Button>}
                        </>}

                        <Button color="warning" onClick={onHandleBack} >
                            <i className="bi bi-arrow-left"></i>
                            <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Back</p>
                        </Button>


                    </CardTitle>
                    <CardBody>
                        <Form >

                            <Row style={{ justifyContent: "center" }}>
                                <Col md="5">
                                    <FormGroup>
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            {
                                                previewImage ?
                                                    <img src={previewImage} style={{
                                                        width: '100px',
                                                        height: '100px',
                                                        borderRadius: '50%',
                                                        marginBottom: '10px',
                                                    }} alt="Preview" />
                                                    :
                                                    companyDetail?.vender_logo ?
                                                        <img src={API_URL + companyDetail?.vender_logo} style={{
                                                            width: '100px',
                                                            height: '100px',
                                                            borderRadius: '50%',
                                                            marginBottom: '10px',
                                                        }} alt="Preview" />
                                                        :
                                                        <>
                                                            <div style={{
                                                                width: '100px',
                                                                height: '100px',
                                                                borderRadius: '50%',
                                                                backgroundColor: 'lightgray',
                                                                backgroundImage: 'url("")',
                                                                backgroundSize: 'cover',
                                                                marginBottom: '10px',
                                                            }} className="rounded-circle"></div>
                                                        </>

                                            }
                                            <Input className="custom-border d-none"
                                                id="vender_logo"
                                                name="vender_logo"
                                                type="file"
                                                innerRef={productImageRef}
                                                onChange={handleInputChange}
                                            />

                                            <Label tag="h6" htmlFor="vender_logo" style={{
                                                width: '150px',
                                                textAlign: 'center'
                                            }} className="upload-button btn btn-primary">
                                                Upload Image
                                            </Label>
                                        </div>
                                        {errors.user_status && <p className="text-danger">{errors.user_status}</p>}

                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_name"> Name</Label>
                                        <Input 
                                            type="text"
                                            name="vender_name"
                                            id="vender_name"
                                            value={companyDetail?.vender_name}
                                            onChange={handleInputChange}
                                            placeholder="Enter name"
                                            disabled={user.user_profile != "superadmin"}
                                        />
                                        {errors.vender_name && <p className="text-danger">{errors.vender_name}</p>}

                                    </FormGroup>
                                </Col >

                                <Col xl={4}>
                                    <Row className="g-1">
                                        <Col xl={5}>
                                            <FormGroup>
                                                <Label tag="h6" for="vender_mobile_code">Mobile Code</Label>
                                                <Input 
                                                    type="select"  className="custom-select"
                                                    name="vender_mobile_code"
                                                    id="vender_mobile_code"
                                                    value={companyDetail?.vender_mobile_code || ''}
                                                    onChange={handleInputChange}
                                                    // disabled={user.user_profile != "superadmin"}
                                                    disabled={editMode}
                                                >
                                                    <option value="" disabled>code</option>
                                                    <option value="+1">+1 US</option>
                                                    <option value="+91">+91 IN</option>
                                                    <option value="+44">+44 UK</option>
                                                    <option value="+81">+81 JP</option>
                                                    <option value="+61">+61 AU</option>
                                                </Input>

                                                {errors.vender_mobile_code && <p className="text-danger">{errors.vender_mobile_code}</p>}

                                            </FormGroup>
                                        </Col>
                                        <Col xl={7}>
                                            <FormGroup>
                                                <Label tag="h6" for="vender_mobile"> Mobile</Label>
                                                <Input 
                                                    type="text"
                                                    name="vender_mobile"
                                                    id="vender_mobile"
                                                    value={companyDetail?.vender_mobile || ''}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter mobile"
                                                    // disabled={user.user_profile != "superadmin"}
                                                    disabled={editMode}
                                                    maxLength={10}

                                                />

                                                {errors.vender_mobile && <p className="text-danger">{errors.vender_mobile}</p>}

                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_email"> Email</Label>
                                        <Input 
                                            type="email"
                                            name="vender_email"
                                            id="vender_email"
                                            value={companyDetail?.vender_email}
                                            onChange={handleInputChange}
                                            placeholder="Enter email"
                                            disabled={user.user_profile != "superadmin"}


                                        />
                                        {errors.vender_email && <p className="text-danger">{errors.vender_email}</p>}

                                    </FormGroup>
                                </Col>

                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_address"> Address</Label>
                                        <Input 
                                            type="text"
                                            name="vender_address"
                                            id="vender_address"
                                            value={companyDetail?.vender_address}
                                            onChange={handleInputChange}
                                            placeholder="Enter address"
                                            disabled={user.user_profile != "superadmin"}

                                        />
                                        {errors.vender_address && <p className="text-danger">{errors.vender_address}</p>}

                                    </FormGroup>
                                </Col>

                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_country"> Country</Label>
                                        <Input 
                                            type="text"
                                            name="vender_country"
                                            id="vender_country"
                                            value={companyDetail?.vender_country}
                                            onChange={handleInputChange}
                                            placeholder="Enter country"
                                            disabled={user.user_profile != "superadmin"}

                                        />
                                        {errors.vender_country && <p className="text-danger">{errors.vender_country}</p>}

                                    </FormGroup>
                                </Col>
                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_state"> State</Label>
                                        <Input 
                                            type="select"  className="custom-select"
                                            name="vender_state"
                                            id="vender_state"
                                            value={companyDetail?.vender_state}
                                            onChange={handleInputChange}
                                            placeholder="Enter state"
                                            disabled={user.user_profile != "superadmin"}

                                        >
                                            <option>Select State</option>
                                            {
                                                stateTable.map((data) => (
                                                    <option value={data.state_Id}>{data.state_Name}</option>
                                                ))
                                            }
                                        </Input>
                                        {errors.vender_state && <p className="text-danger">{errors.vender_state}</p>}

                                    </FormGroup>
                                </Col>
                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_city"> City</Label>
                                        <Input 
                                            type="select"  className="custom-select"
                                            name="vender_city"
                                            id="vender_city"
                                            value={companyDetail?.vender_city}
                                            onChange={handleInputChange}
                                            placeholder="Enter city"
                                            disabled={user.user_profile != "superadmin"}

                                        >

                                            <option>Select City</option>
                                            {
                                                cityTable.map((data) => (
                                                    <option value={data.id}>{data.city_name}</option>
                                                ))
                                            }
                                        </Input>

                                        {errors.vender_city && <p className="text-danger">{errors.vender_city}</p>}

                                    </FormGroup>
                                </Col>

                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_pincode"> Pincode</Label>
                                        <Input 
                                            type="text"
                                            name="vender_pincode"
                                            id="vender_pincode"
                                            value={companyDetail?.vender_pincode}
                                            onChange={handleInputChange}
                                            placeholder="Enter pincode"
                                            disabled={user.user_profile != "superadmin"}

                                        />
                                        {errors.vender_pincode && <p className="text-danger">{errors.vender_pincode}</p>}

                                    </FormGroup>
                                </Col>

                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="working_bussinesss_mode"> Business Mode</Label>
                                        <Input 
                                            type="select"  className="custom-select"
                                            name="working_bussinesss_mode"
                                            id="working_bussinesss_mode"
                                            value={companyDetail?.working_bussinesss_mode}
                                            onChange={handleInputChange}
                                            placeholder="Enter pincode"
                                            disabled={user.user_profile != "superadmin"}

                                        >
                                            <option>Select Business Mode</option>
                                            {
                                                helperMasterBusinessMode.map((data) => (
                                                    <option value={data.field_data}>{data.field_name}</option>
                                                ))
                                            }
                                        </Input>

                                        {errors.working_bussinesss_mode && <p className="text-danger">{errors.working_bussinesss_mode}</p>}
                                    </FormGroup>
                                </Col>


                                <Col xl={4}>
                                    <FormGroup>
                                        <Label tag="h6" for="vender_website_lunch"> Vender Website [Y/N]</Label>
                                        <Input 
                                            type="select"  className="custom-select"
                                            name="vender_website_lunch"
                                            id="vender_website_lunch"
                                            value={companyDetail?.vender_website_lunch}
                                            onChange={handleInputChange}
                                            placeholder="Select Option"
                                        >
                                            <option value="">-- Select --</option>
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                        </Input>
                                        {errors.vender_website_lunch && <p className="text-danger">{errors.vender_pincode}</p>}

                                    </FormGroup>
                                </Col>

                                {companyDetail.vender_website_lunch === "yes" && <div>



                                    <Alert color="warning" className="d-flex align-items-center py-2 px-3" style={{}}>
                                        <span className="mr-2" style={{ fontSize: "1.2rem" }}>🌍</span>
                                        <h5 className="mb-0 fw-bold">
                                            Lunch the Website
                                        </h5>
                                    </Alert>
                                    <Row>


                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for='company_name'>Company Name</Label>
                                                <Input 
                                                    id='company_name'
                                                    name='company_name'
                                                    value={venderWebsitePage?.company_name}
                                                    onChange={onChangeHandle}
                                                />
                                                {errors.name && (
                                                    <FormText color='danger'>
                                                        {errors.company_name}
                                                    </FormText>
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col sm={4}>


                                            <FormGroup>
                                                <Label tag="h6" for='email_sender'>Company Email</Label>
                                                <Input 
                                                    id='email_sender'
                                                    name='email_sender'
                                                    value={venderWebsitePage?.email_sender}
                                                    onChange={onChangeHandle}
                                                />
                                                {errors.name && (
                                                    <FormText color='danger'>
                                                        {errors.email_sender}
                                                    </FormText>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for='company_phone'>Company Phone</Label>
                                                <Input 
                                                    id='company_phone'
                                                    name='company_phone'
                                                    value={venderWebsitePage?.company_phone}
                                                    onChange={onChangeHandle}
                                                />
                                                {errors.name && (
                                                    <FormText color='danger'>
                                                        {errors.company_phone}
                                                    </FormText>
                                                )}
                                            </FormGroup>
                                        </Col>

                                        <Col sm={6}>
                                            <FormGroup>

                                                <Label tag="h6" for='company_address'>Company Address 1</Label>
                                                <Input 
                                                    id='company_address'
                                                    name='company_address'
                                                    value={venderWebsitePage?.company_address}
                                                    onChange={onChangeHandle}
                                                />
                                                {errors.name && (
                                                    <FormText color='danger'>
                                                        {errors.company_address}
                                                    </FormText>
                                                )}
                                            </FormGroup>
                                        </Col>


                                        <Col sm={6}>
                                            <FormGroup>
                                                <Label tag="h6" for='company_address_1'>Company Address 2</Label>
                                                <Input 
                                                    id='company_address_1'
                                                    name='company_address_1'
                                                    value={venderWebsitePage?.company_address_1}
                                                    onChange={onChangeHandle}
                                                />
                                                {errors.name && (
                                                    <FormText color='danger'>
                                                        {errors.company_address_1}
                                                    </FormText>
                                                )}
                                            </FormGroup>
                                        </Col>


                                        <Row className="d-flex justify-content-between">
                                            <Col sm={4}>

                                                {(true) && (
                                                    <FormGroup className="text-center border rounded p-2 bg-white"
                                                        style={{
                                                            height: 160,
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            flexDirection: "column",
                                                            position: "relative",
                                                            overflow: "hidden",
                                                        }}>
                                                        <img
                                                            src={previewVenderWebsiteImage || "/images/img_placeholder.png"}
                                                            alt="No Preview"
                                                            className="img-fluid rounded mb-2"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                maxWidth: "100%",
                                                                maxHeight: "100%",
                                                                objectFit: "contain",
                                                                borderRadius: "0.25rem",
                                                                // backgroundColor: "#f0f0f0",
                                                                overflow: "hidden"
                                                            }}
                                                        />

                                                        {/* Action buttons */}
                                                        {previewVenderWebsiteImage && <div className="d-flex justify-content-center gap-2">
                                                            <a
                                                                href={previewVenderWebsiteImage}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-outline-secondary"
                                                                title="View Image"
                                                            >
                                                                <i className="bi bi-eye"></i>
                                                            </a>

                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                title="Remove Image"
                                                                onClick={() => {
                                                                    setPreviewVenderWebsiteImage(null);
                                                                    setVenderWebsitePage(prev => ({
                                                                        ...prev,
                                                                        company_image: null
                                                                    }));
                                                                }}
                                                            >
                                                                <i className="bi bi-x-lg"></i>
                                                            </button>
                                                        </div>}
                                                    </FormGroup>
                                                )}
                                                <FormGroup>
                                                    <Label tag="h6" for="company_image">Company Image</Label>
                                                    <Input 
                                                        type="file"
                                                        name="company_image"
                                                        id="company_image"
                                                        // value={venderWebsitePage?.company_image}
                                                        onChange={onChangeHandle}
                                                    />

                                                </FormGroup>
                                            </Col>
                                            <Col sm={4}>



                                                {(true) && (
                                                    <FormGroup className="text-center border rounded p-2 bg-white" style={{
                                                        height: 160,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        flexDirection: "column",
                                                        position: "relative",
                                                        overflow: "hidden"
                                                    }}>
                                                        <img
                                                            src={previewVenderWebsiteLogo || "/images/img_placeholder.png"}
                                                            alt="No Preview"
                                                            className="img-fluid rounded mb-2"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                maxWidth: "100%",
                                                                maxHeight: "100%",
                                                                objectFit: "contain",
                                                                borderRadius: "0.25rem",
                                                                // backgroundColor: "#f0f0f0",
                                                                overflow: "hidden"

                                                            }}
                                                        />

                                                        {/* Action buttons */}
                                                        {previewVenderWebsiteLogo && <div className="d-flex justify-content-center gap-2">
                                                            <a
                                                                href={previewVenderWebsiteLogo}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-outline-secondary"
                                                                title="View Image"
                                                            >
                                                                <i className="bi bi-eye"></i>
                                                            </a>

                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                title="Remove Image"
                                                                onClick={() => {
                                                                    setPreviewVenderWebsiteLogo(null);
                                                                    setVenderWebsitePage(prev => ({
                                                                        ...prev,
                                                                        company_logo: null
                                                                    }));
                                                                }}
                                                            >
                                                                <i className="bi bi-x-lg"></i>
                                                            </button>
                                                        </div>}
                                                    </FormGroup>
                                                )}

                                                <FormGroup>
                                                    <Label tag="h6" for="company_logo">Company Logo</Label>
                                                    <Input 
                                                        type="file"
                                                        name="company_logo"
                                                        id="company_logo"
                                                        // value={venderWebsitePage?.company_image}
                                                        onChange={onChangeHandle}
                                                    />

                                                </FormGroup>
                                            </Col>

                                            <Col sm={4}>


                                                {(true) && (
                                                    <FormGroup className="text-center border rounded p-2 bg-white" style={{
                                                        height: 160,
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        flexDirection: "column",
                                                        position: "relative",
                                                        overflow: "hidden"
                                                    }}>
                                                        <img
                                                            src={previewVenderWebsiteBreadcrumbImg || "/images/img_placeholder.png"}
                                                            alt="No Preview"
                                                            className="img-fluid rounded mb-2"
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                maxWidth: "100%",
                                                                maxHeight: "100%",
                                                                objectFit: "contain",
                                                                borderRadius: "0.25rem",
                                                                overflow: "hidden"

                                                                // backgroundColor: "#f0f0f0",
                                                            }}
                                                        />

                                                        {/* Action buttons */}
                                                        {previewVenderWebsiteBreadcrumbImg && <div className="d-flex justify-content-center gap-2 ">
                                                            <a
                                                                href={previewVenderWebsiteBreadcrumbImg}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="btn btn-outline-secondary"
                                                                title="View Image"

                                                            >
                                                                <i className="bi bi-eye" ></i>
                                                            </a>

                                                            <button
                                                                type="button"
                                                                className="btn btn-danger"
                                                                title="Remove Image"
                                                                onClick={() => {
                                                                    setPreviewVenderWebsiteBreadcrumbImg(null);
                                                                    setVenderWebsitePage(prev => ({
                                                                        ...prev,
                                                                        breadcrumb_img: null
                                                                    }));
                                                                }}
                                                            >
                                                                <i className="bi bi-x-lg"></i>
                                                            </button>
                                                        </div>}
                                                    </FormGroup>
                                                )}
                                                <FormGroup>
                                                    <Label tag="h6" for="breadcrumb_img">Breadcrumb Image</Label>
                                                    <Input 
                                                        type="file"
                                                        name="breadcrumb_img"
                                                        id="breadcrumb_img"
                                                        // value={venderWebsitePage?.company_image}
                                                        onChange={onChangeHandle}
                                                    />

                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Col sm={12}>
                                            <FormGroup>
                                                <Label tag="h6" for="company_about_title">Company About Title</Label>
                                                <Input 
                                                    type="text"
                                                    name="company_about_title"
                                                    id="company_about_title"
                                                    value={venderWebsitePage?.company_about_title}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>

                                            <FormGroup>
                                                <Label tag="h6" for="company_about">Company About</Label>

                                                <CkEditor
                                                    name="category_content"
                                                    onChange={(data) => {
                                                        setVenderWebsitePage((prevData) => ({
                                                            ...prevData,
                                                            company_about: data,
                                                        }));
                                                    }}
                                                    editorLoaded={editorLoaded}
                                                    value={venderWebsitePage?.company_about || ""}
                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>



                                            <FormGroup>
                                                <Label tag="h6" for="footer_company_about">Company Footer About</Label>
                                                <Input 
                                                    type="text"
                                                    name="footer_company_about"
                                                    id="footer_company_about"
                                                    value={venderWebsitePage?.footer_company_about}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>

                                            <FormGroup>
                                                <Label tag="h6" for="private_policy">Private Policy</Label>

                                                <CkEditor
                                                    name="private_policy"
                                                    onChange={(data) => {
                                                        setVenderWebsitePage((prevData) => ({
                                                            ...prevData,
                                                            private_policy: data,
                                                        }));
                                                    }}
                                                    editorLoaded={editorLoaded}
                                                    value={venderWebsitePage?.private_policy || ""}
                                                />

                                            </FormGroup>
                                        </Col>
                                        <Col sm={12}>

                                            <FormGroup>
                                                <Label tag="h6" for="term_condition">Company Terms&Condition</Label>

                                                <CkEditor
                                                    name="term_condition"
                                                    onChange={(data) => {
                                                        setVenderWebsitePage((prevData) => ({
                                                            ...prevData,
                                                            term_condition: data,
                                                        }));
                                                    }}
                                                    editorLoaded={editorLoaded}
                                                    value={venderWebsitePage?.term_condition || ""}
                                                />

                                            </FormGroup>
                                        </Col>

                                        <Col sm={4}>

                                            <FormGroup>
                                                <Label tag="h6" for="facebook_link">FaceBook Link</Label>
                                                <Input 
                                                    type="text"
                                                    name="facebook_link"
                                                    id="facebook_link"
                                                    value={venderWebsitePage?.facebook_link}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={4}>

                                            <FormGroup>
                                                <Label tag="h6" for="twitter_link">Twitter Link</Label>
                                                <Input 
                                                    type="text"
                                                    name="twitter_link"
                                                    id="twitter_link"
                                                    value={venderWebsitePage?.twitter_link}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={4}>


                                            <FormGroup>
                                                <Label tag="h6" for="youtube_link">Youtube Link</Label>
                                                <Input 
                                                    type="text"
                                                    name="youtube_link"
                                                    id="youtube_link"
                                                    value={venderWebsitePage?.youtube_link}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={4}>

                                            <FormGroup>
                                                <Label tag="h6" for="linkedin_link">Linkedin Link</Label>
                                                <Input 
                                                    type="text"
                                                    name="linkedin_link"
                                                    id="linkedin_link"
                                                    value={venderWebsitePage?.linkedin_link}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={4}>



                                            <FormGroup>
                                                <Label tag="h6" for="map_link">Site/Map Link</Label>
                                                <Input 
                                                    type="text"
                                                    name="map_link"
                                                    id="map_link"
                                                    value={venderWebsitePage?.map_link}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for="business_card_link">Business Card Link</Label>
                                                <Input 
                                                    type="text"
                                                    name="business_card_link"
                                                    id="business_card_link"
                                                    value={venderWebsitePage?.business_card_link}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>



                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for="comp_meta_title">Company Meta Title</Label>
                                                <Input
                                                    type="text"
                                                    name="comp_meta_title"
                                                    id="comp_meta_title"
                                                    value={venderWebsitePage?.comp_meta_title}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for="comp_meta_desc">Company Meta Description</Label>
                                                <Input
                                                    type="text"
                                                    name="comp_meta_desc"
                                                    id="comp_meta_desc"
                                                    value={venderWebsitePage?.comp_meta_desc}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for="comp_meta_keyword">Company Meta Keyword</Label>
                                                <Input
                                                    type="text"
                                                    name="comp_meta_keyword"
                                                    id="comp_meta_keyword"
                                                    value={venderWebsitePage?.comp_meta_keyword}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for="about_us_meta_title">About Us Meta Title</Label>
                                                <Input
                                                    type="text"
                                                    name="about_us_meta_title"
                                                    id="about_us_meta_title"
                                                    value={venderWebsitePage?.about_us_meta_title}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for="about_us_meta_desc">About Us Meta Description</Label>
                                                <Input
                                                    type="text"
                                                    name="about_us_meta_desc"
                                                    id="about_us_meta_desc"
                                                    value={venderWebsitePage?.about_us_meta_desc}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col sm={4}>
                                            <FormGroup>
                                                <Label tag="h6" for="about_us_meta_keyword">About Us Meta Keyword</Label>
                                                <Input
                                                    type="text"
                                                    name="about_us_meta_keyword"
                                                    id="about_us_meta_keyword"
                                                    value={venderWebsitePage?.about_us_meta_keyword}
                                                    onChange={onChangeHandle}
                                                />
                                            </FormGroup>
                                        </Col>


                                    </Row>



                                </div>
                                }


                            </Row>
                        </Form>

                    </CardBody>

                    {/* Error Model */}
                    <ErrorModal
                        show={showErrorModal}
                        title="Validation / Action Required"
                        content={errors}
                        condition={true}
                        onCancel={() => setShowErrorModal(false)}
                    // onConfirm={true}
                    />
                </Card>
            </Col>



        </Row>
    );
};

export default AddVenderMaster;

